/** Preferences are optional: restricted browser storage must never break navigation. */
export function readPreference<T>(key: string, fallback: T): T {
  try { const value = localStorage.getItem(`svetoch:${key}`); return value === null ? fallback : JSON.parse(value) as T; }
  catch { return fallback; }
}

export function writePreference(key: string, value: unknown) {
  try { localStorage.setItem(`svetoch:${key}`, JSON.stringify(value)); } catch { /* Storage is optional. */ }
}
